import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import commentsReducer from './data/reducer';
import commentsSaga from './data/sagas';
import entitiesReducer from './entities/reducer';
import sharesReducer from './shares/data/reducer';
import sharesSaga from './shares/data/sagas';
import tasksReducer from './tasks/data/reducer';
import tasksSaga from './tasks/data/sagas';

const reducer = combineReducers({
  chat: commentsReducer,
  data: entitiesReducer,
  shares: sharesReducer,
  tasks: tasksReducer,
});

const saga = function* () {
  yield all([commentsSaga(), sharesSaga(), tasksSaga()]);
};

export { reducer, saga };
